module.exports = __webpack_public_path__ + "static/media/vocals-head.450d8efb.jpg";